import axios from "axios";

/**
 * Add products to cart
 * @param  {Object} items – Products to add.
 */
export async function addToCartApi(items) {

  try {
    const response = await axios.post(
      `${routes.cart_add_url}.js`,
      { items },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    return error;
  }
}

/**
 * Get data from a resource
 * @param  {string} url – The path of the resource to obtain.
 */
export async function readApi(url) {
  try {
    const response = await axios.get(url);

    return response.data;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

/**
 * Update the cart's line item quantities.
 * @param  {Object} config – Contains the product variant and
 * the quantity to update.
 */
export async function updateCart(config) {
  
  try {
    const response = await axios.post(
      `${routes.cart_change_url}.js`,
      config,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

export async function updateIds(config) {
  try {
    const response = await axios.post(
      `${routes.cart_update_url}.js`,
      { updates:config },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

/**
 * Update a specific section with the use of Section Rendering API
 * @param {String} sectionId – Section ID.
 * @returns {Object} Section ID and its corresponding rendered HTML
 */
export async function updateShopifySection(sectionId) {
  try {
    const response = await axios.get(`?section_id=${sectionId}`);

    return response.data;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}
